<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Create Font Pairing</h1>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="8"
                align="center"
                justify="center"
            >
                <FontPairingEditForm />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Overlay from '../../../../components/Overlay';
import { mapActions } from 'vuex';
import FontPairingEditForm from '@/views/Admin/Config/FontPairing/FontPairingEditForm';

export default {
    components: { FontPairingEditForm, Overlay },

    mounted() {
        this.resetState().then(() => {
            this.getData();
        });
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'fontPairingEditor/getData',
            saveData: 'fontPairingEditor/saveData',
            resetState: 'paletteEditor/resetState'
        }),
    }
};
</script>
